/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthPolicyService } from '../services/auth-policy.service';

@Directive({
  selector: '[appUserRole]'
})
export class UserRoleDirective {
  private _subscriptions: Subscription[] = [];
  userRoles: string;

  @Input() set appUserRole(roles: string[]) {
    this.getUserRole(roles);
  } 


  constructor(private _authService: AuthPolicyService, private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef) { }

  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }
  getUserRole(roles: string[]) {
    // roles=['Admin'];
    this._subscriptions.push(
      // Move to app context if used in many places and Mutliple Roles Scenario
      this._authService.getUserRoles().subscribe(role => {
        if (role) {
          this.userRoles = role.roleName;
          let isUserHasValidRole = false;

          roles.forEach(role => {
            if (role.toLowerCase() === this.userRoles?.toLowerCase()) {
              isUserHasValidRole = true;
            }
          });
          if (isUserHasValidRole) {
            this._viewContainer.createEmbeddedView(this._templateRef);
          } else {
            this._viewContainer.clear();
          }

        }
      }, error => {
        this._viewContainer.clear();
      })
    );
  }
}
